import React, { useEffect, useState } from 'react';
import Formulario from './OrdenServicioForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

function OrdenServicio(props) {
    const { loader, periodoD, modulo, 
        listarClientes, detalleProducto,
        detalleOrden, registroOrden, detalleOrd,
        modificarOrden, lectura
    } = props;        
        
    useEffect(() => {
        const { match, leer, getModulo, leerPeriodoD } = props;
        const id = match.params.id;
        if (id) {
            setCrear(false);
            leer(id);
        }
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        leerPeriodoD(periodo[5], periodo[7]);
        getModulo(periodo[5], periodo[4]);
    }, [])

    const [crear, setCrear] = useState(true);

    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar proyecto' : 'Crear proyecto';
    
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver proyecto';
    }

    return (
        <LoadMask loading={loader} dark>
            <Formulario
                registroOrden = {registroOrden}
                modificarOrden = {modificarOrden}
                crear = {crear}
                titulo = {titulo}
                editar = {editar}
                periodoD = {periodoD}
                modulo = {modulo}
                bloqueo = {disabled}
                listarClientes = {listarClientes}
                detalleProducto = {detalleProducto}
                detalleOrden = {detalleOrden}
                detalleOrd = {detalleOrd}
                lectura = {lectura}
            />
        </LoadMask>
    );
}

export default OrdenServicio;